<app-popup-header [attr.aria-label]="'Popup header ' + data.title"
                  *ngIf="!data?.showCustomHeader"
                  [title]="data.title"
                  [showBorder]="!data.hideHeaderBorder"
                  [subTitle]="data.subTitle"
                  (closePopup)="onClose()" />

<ng-container #dialogContent></ng-container>

<app-popup-footer [attr.aria-label]="'Popup footer ' + data.title"
                  [ngClass]="footerClass"
                  class="mt-auto"
                  *ngIf="showFooter && data.buttons && data.buttons.length > 0"
                  [buttons]="data.buttons" />
